import { HelmetProvider } from 'react-helmet-async';
import { AboutPage } from './AboutPage';
import { ensureHqAnalytics } from './analytics';
import { currentHqPath } from './detect';
import { HQ_NAME } from './config';
import { GUIDES_BY_SLUG } from './guides';
import { GuidePage } from './GuidePage';
import { GuidesIndexPage } from './GuidesIndexPage';
import { HomePage } from './HomePage';
import { HqLayout, useHqPath } from './layout';
import { HqLink } from './Link';
import { ToolsPage } from './ToolsPage';

function NotFoundPage() {
  return (
    <HqLayout
      title={`Page not found: ${HQ_NAME}`}
      description={`That page is not on ${HQ_NAME}.`}
      path={currentHqPath()}
    >
      <h1 className='font-hq text-3xl font-medium'>This page is not here</h1>
      <p className='mt-3 text-hq-muted'>
        Try the{' '}
        <HqLink to='/' className='font-medium text-hq-sage hover:underline'>
          starting place
        </HqLink>
        , the{' '}
        <HqLink to='/tools' className='font-medium text-hq-sage hover:underline'>
          tool list
        </HqLink>
        , or{' '}
        <HqLink to='/about' className='font-medium text-hq-sage hover:underline'>
          about this site
        </HqLink>
        .
      </p>
    </HqLayout>
  );
}

function HqRoutes() {
  const path = useHqPath();
  if (path === '/' || path === '/start') {
    return <HomePage />;
  }
  if (path === '/tools') {
    return <ToolsPage />;
  }
  if (path === '/guides') {
    return <GuidesIndexPage />;
  }
  if (path === '/about') {
    return <AboutPage />;
  }
  if (path.startsWith('/guides/')) {
    const slug = path.slice('/guides/'.length);
    const guide = GUIDES_BY_SLUG[slug];
    if (guide) {
      return <GuidePage guide={guide} />;
    }
  }
  return <NotFoundPage />;
}

export function HqApp() {
  ensureHqAnalytics();
  return (
    <HelmetProvider>
      <HqRoutes />
    </HelmetProvider>
  );
}
